import React from 'react'
import styled from 'styled-components'
import { theme } from '@mtsdengi/ui-kit'
import { SmartText, SmartVisibleChild } from '@mtsdengi/common'
import { MetricsEvent } from '@shared/utils'
import { MtsDengiButton } from '@shared/components'

const Grid = styled.div`
  display: grid;
  gap: ${theme.spacings.xs2}px;
  align-items: center;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    gap: ${theme.spacings.sm}px;
    grid-template-columns: auto 198px;
  }
`

export type FooterProps = {
  hasNext: boolean
  onNext: () => void
  agreement: string
}

export const Footer = ({ hasNext, onNext, agreement }: FooterProps) => {
  if (!hasNext) {
    return null
  }

  return (
    <Grid>
      <SmartVisibleChild conditions={{ none: 'none', tablet: 'block' }}>
        <SmartText
          fontFamily={theme.fonts.font_family_comp}
          fontSizeTablet={theme.fonts.font_sizes.par.lg}
          lineHeightTablet={theme.fonts.line_heights.par.lg}
        >
          {agreement}
        </SmartText>
      </SmartVisibleChild>
      <MetricsEvent.Click label="prodolzhit">
        <MtsDengiButton fluidMob sizemob={theme.sizes.greater.lg} size={theme.sizes.greater.xl} onClick={onNext}>
          Продолжить
        </MtsDengiButton>
      </MetricsEvent.Click>
      <SmartVisibleChild conditions={{ none: 'block', tablet: 'none' }}>
        <SmartText
          fontFamily={theme.fonts.font_family_comp}
          fontSizeMob={theme.fonts.font_sizes.par.md}
          lineHeightMob={theme.fonts.line_heights.par.md}
          textAlign="center"
        >
          {agreement}
        </SmartText>
      </SmartVisibleChild>
    </Grid>
  )
}
